/**
 * 通用工具方法
 */
import moment from 'moment';
class Utils {
    // 设置cookie
    static setCookie(name, value, ...args) {
        let exDate = args.length ? moment().add(...args).utc().toString() : null;
        document.cookie = name + "=" + escape(value) + ((exDate === null) ? "" : ";expires=" + exDate);
    }
    // 获取cookie
    static getCookie(name) {
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    // 删除cookie
    static delCookie(name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let value = Utils.getCookie(name);
        if (value != null)
            document.cookie = name + "=" + value + ";expires=" + exp.toUTCString();
    }
    // 操作授权token
    static runAuth(funName, ...args) {
        funName += 'Cookie';
        args.unshift('XW_Authorization');
        return Utils[funName](...args);
    }

    /**
     * 获取字符串长度(中文=2)
     * @param str
     * @returns {number}
     */
    static getCharsLength(str = '') {
        let count = 0;
        for (let char of str) {
            count += new RegExp('[\u4e00-\u9fa5]').test(char) ? 2 : 1;
        }
        return count;
    }

    /**
     * 超过长度截取字符串(中文=2)
     * @param str
     * @param length
     * @returns {*}
     */
    static sliceCharsLength(str = '', length = 100) {
        let index = 0,
            count = 0;
        for (let char of str) {
            count += new RegExp('[\u4e00-\u9fa5]').test(char) ? 2 : 1;
            if (count >= length) {
                str = str.slice(0, index) + '...';
                break;
            }
            index++;
        }
        return str;
    }
}

export default Utils;



// WEBPACK FOOTER //
// ./app/store/utils.js